/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Settings/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Settings({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Settings",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Settings.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 14"
 style={{'--as-1-ZFs5Ov': alignSelf,'--mt-2-ZFs5Ov': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZFs5Ov': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZFs5Ov': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZFs5Ov': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZFs5Ov': opacity,'--w-10-ZFs5Ov': typeof width === 'number' ? `${width}px` : width,'--h-11-ZFs5Ov': typeof height === 'number' ? `${height}px` : height,'--f-12-ZFs5Ov': fill,'--a-7-ZFs5Ov': isAnimated ? animation : "none",'--sd-8-ZFs5Ov': isAnimated ? strokeDashoffset : 0,'--sd-9-ZFs5Ov': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Settings.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.653 1.14L4.22 2.25l-1.487.84-1.187-.18a1.01 1.01 0 00-1.005.49l-.402.7a.996.996 0 00.08 1.13l.754.93v1.68l-.734.93A.997.997 0 00.16 9.9l.402.7a1.003 1.003 0 001.005.49l1.187-.18 1.467.84.433 1.11a1 1 0 00.935.64h.844a1.01 1.01 0 00.935-.64l.433-1.11 1.467-.84 1.187.18a1.01 1.01 0 001.005-.49l.402-.7a.996.996 0 00-.08-1.13l-.754-.93V6.16l.734-.93a.997.997 0 00.08-1.13l-.402-.7a1.004 1.004 0 00-1.005-.49l-1.187.18-1.467-.84-.433-1.11A1.001 1.001 0 006.412.5h-.824a1.01 1.01 0 00-.935.64zM6 9.09c1.16 0 2.1-.936 2.1-2.09S7.16 4.91 6 4.91c-1.16 0-2.1.936-2.1 2.09S4.84 9.09 6 9.09z"
 style={{'--f-12-ZFs5Ov': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}